const validator = {
    /**
     * Validate login
     * 
     * @param {string} login - The login to validate.
     * @return {string} - Returns error message if validation fails.
     */
    validateLogin: (login) => {
        if (!login) {  return "Login is required"; }
        if (login.length < 3) { return "Login must be at least 3 characters long"; }
        if (login.length > 20) { return "Login must be at most 20 characters long"; }
        return null;
    },
    /**
     * Validate email
     * 
     * @param {string} email - The email to validate.
     * @return {string} - Returns error message if validation fails.
     */
    validateEmail: (email) => {
        if (!email) { return "Email is required"; }
        const re = /\S+@\S+\.\S+/;
        if (!re.test(email)) { return "Email is not valid"; }
        return null;
    },

    /**
     * Validate password
     * @param {string} password - The password to validate.
     * @return {string} - Returns error message if validation fails.
     */
    validatePassword: (password) => {
        if (!password) { return "Password is required"; }
        if (password.length < 6) { return "Password must be at least 6 characters long"; }
        if (password.length > 20) { return "Password must be at most 20 characters long"; }
        return null;
    },

    /**
     * Validate driver ID
     * @param {number} driverId - The driver ID to validate.
     * @return {string} - Returns error message if validation fails.
     */
    validateDriverId: (driverId) => {
        if (!driverId) { return "Driver ID is required"; }
        if (isNaN(driverId)) { return "Driver ID must be a number"; }
        if (driverId < 0) { return "Driver ID must be a positive number"; }
        if (!Number.isInteger(driverId)) { return "Driver ID must be an integer"; }
        if (driverId > 99999) { return "Driver ID is too large"; }
        return null;
    },

    ////////////////////////////////////////////////////////////////////////////

    /**
     * Validates the provided login.
     * 
     * @param {string} login 
     * @throws {Error} error message if validation fails
     */
    mustValidateLogin: (login) => {
        const error = validator.validateLogin(login);
        if (error) { throw new Error(error); }
    },

    /**
     * Validates the provided email.
     * 
     * @param {string} email - The email address to validate.
     * @throws {Error} error message if validation fails
     */

    mustValidateEmail: (email) => {
        const error = validator.validateEmail(email);
        if (error) { throw new Error(error); }
    },

    /**
     * Validates the provided password.
     * 
     * @param {string} password - The password to validate.
     * @throws {Error} error message if validation fails
     */
    mustValidatePassword: (password) => {
        const error = validator.validatePassword(password);
        if (error) { throw new Error(error); }
    },

    /**
     * Validates the provided driver ID.
     * 
     * @param {number} driverId - The driver ID to validate.
     * @throws {Error} error message if validation fails
     */
    mustValidateDriverId: (driverId) => {
        const error = validator.validateDriverId(driverId);
        if (error) { throw new Error(error); }
    },
}

export function useValidation() {
    return {
        validateLogin: validator.validateLogin,
        validateEmail: validator.validateEmail,
        validatePassword: validator.validatePassword,
        validateDriverId: validator.validateDriverId
    }
}